const urlPrefix = 'digital-learning'

const pages = {
  index: {
    'pt-br': `/hotmartacademy`,
    en: `/${urlPrefix}`,
    es: `/${urlPrefix}`,
    co: `/${urlPrefix}`,
    mx: `/${urlPrefix}`,
    la: `/${urlPrefix}`,
  },
  'thank-you': {
    co: `/${urlPrefix}/gracias`,
    mx: `/${urlPrefix}/gracias`,
    la: `/${urlPrefix}/gracias`,
  },
}

export default pages
